import { Grid, Stack, StyleProp, Text } from '@mantine/core';
import { ColSpan } from '@mantine/core/lib/components/Grid/GridCol/GridCol';
import React from 'react';

interface IllustrationStateProps {
  Illustration: React.ReactNode;
  title?: string;
  description?: string;
  titleSize?: number;
  titleColor?: string;
  descriptionSize?: number;
  descriptionColor?: string;
  span?: StyleProp<ColSpan>;
  isIlustration?: boolean;
}

const IllustrationState: React.FC<IllustrationStateProps> = ({
  Illustration,
  title,
  descriptionColor,
  titleColor,
  description,
  titleSize = 20,
  descriptionSize = 14,
  span = { base: 12, md: 6 },
  isIlustration = true
}) => {
  return (
    <Grid justify="center" align="center" py={16} w={'100%'}>
      <Grid.Col span={span}>
        <Stack gap={8} justify="center" align="center">
          {isIlustration ? Illustration : null}
          <Stack gap={0} align="center">
            <Text
              miw={200}
              fz={titleSize}
              fw={700}
              style={{ textAlign: 'center', color: titleColor }}
            >
              {title}
            </Text>
            <Text
              fz={descriptionSize}
              fw={500}
              c={'gray'}
              style={{ textAlign: 'center', color: descriptionColor }}
            >
              {description}
            </Text>
          </Stack>
        </Stack>
      </Grid.Col>
    </Grid>
  );
};

export default IllustrationState;
